<template>
  <v-app>
    <v-main>
      <v-container class="transaction-cancelled fill-height">
        <v-row justify="center" align="center" class="fill-height">
          <v-col cols="12" md="6" lg="4">
            <v-card elevation="4" class="pa-8">
              <div class="text-center">
                <v-icon color="error" size="100" class="mb-6">mdi-close-circle</v-icon>
                <h2 class="text-h4 font-weight-medium mb-4">
                  {{ $t('global.transaction.cancelledTitle') || 'Payment Cancelled' }}
                </h2>
                <p class="text-body-1 text--secondary mb-8">
                  {{
                    $t('global.transaction.cancelledMessage') ||
                    'Your payment has been cancelled. No charges have been made.'
                  }}
                </p>
                <v-btn color="primary" large block @click="retryPayment" class="mb-3">
                  <v-icon left>mdi-refresh</v-icon>
                  {{ $t('global.transaction.retryPayment') || 'Try Again' }}
                </v-btn>
                <v-btn outlined large block @click="goToDashboard">
                  <v-icon left>mdi-arrow-left</v-icon>
                  {{ deviceId ? 'Return to Device' : 'Go to Dashboard' }}
                </v-btn>
              </div>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
export default {
  name: 'TransactionCancelled',
  data() {
    return {
      deviceId: null,
    }
  },
  mounted() {
    const transactionId = this.$route.query.transId
    this.deviceId = this.$route.query.deviceId

    if (!transactionId) {
      console.warn('No transactionId found in route params')
    }
    // Payment was cancelled
    console.log('Payment cancelled for transaction:', transactionId)
  },
  methods: {
    goToDashboard() {
      if (this.deviceId) {
        // Encode the device ID in Relay format (Base64 of "Device:id")
        const encodedDeviceId = btoa(`Device:${this.deviceId}`)
        const baseUrl = window.location.origin
        window.location.href = `${baseUrl}/app/device/${encodedDeviceId}`
      } else {
        const baseUrl = window.location.origin
        window.location.href = `${baseUrl}/app`
      }
    },
    retryPayment() {
      // Go back to device subscription page to retry
      if (this.deviceId) {
        // Encode the device ID in Relay format (Base64 of "Device:id")
        const encodedDeviceId = btoa(`Device:${this.deviceId}`)
        const baseUrl = window.location.origin
        window.location.href = `${baseUrl}/app/device/${encodedDeviceId}?openSubscription=true`
      } else {
        const baseUrl = window.location.origin
        window.location.href = `${baseUrl}/app`
      }
    },
  },
}
</script>

<style lang="less" scoped>
.transaction-cancelled {
  background-color: #f5f5f5;
}
</style>
